const initialState = {
  open: false,
  formData: null,
  submitSuccess: false,
  submitError: null,
  submitInProgress: false,
  continue: false,
  context: 'eta',
};
export default initialState;
